import { useEffect, useState } from "react";
import TrainingService from "../Service/TrainingService";
import CalendarView from "../Vue/Pages/CalendarView";
import TrainingModel from "../Model/TrainingModel"

const CalendarController = () => {
  const [session, setSession] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchTrainings(); // Fetch avec les dates
  }, [])

  const formatDateToDDMMYYYY = (date) => {
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0'); // Les mois commencent à 0
    const year = date.getFullYear();
    return `${day}-${month}-${year}`;
  };

  const fetchTrainings = async () => {
    try {
      const response = await TrainingService.fetchSessions();
      console.log(response.data.training_sessions);

      let sessions = [];
      for (const data of response.data.training_sessions) {
        console.log(data);

        // Vérifier si la session est publique
        if (data.public_display === true) {
          const startDate = new Date(data.start_date);
          const endDate = new Date(data.end_date);

          const calculatedDays = Math.ceil((endDate - startDate + 1) / (1000 * 60 * 60 * 24));
          const roundedDays = Math.ceil(data.days);

          if (calculatedDays !== roundedDays) {
            console.warn(`Les jours calculés (${calculatedDays}) ne correspondent pas à data.days arrondi (${roundedDays}). Réappel de l'API...`);

            // Réappeler l'API pour obtenir des données détaillées
            const detailedResponse = await TrainingService.fetchDetailedSessions(data.id);
            console.log("Détails récupérés :", detailedResponse.courses);

            // Vérifier si les données des demi-journées existent
            if (detailedResponse?.courses) {
              // Regrouper les demi-journées par date
              const groupedByDate = detailedResponse.courses.reduce((acc, halfDay) => {
                const date = halfDay.date;
                if (!acc[date]) {
                  acc[date] = [];
                }
                acc[date].push(halfDay);
                return acc;
              }, {});

              // Créer une session par journée
              for (const [date, halfDays] of Object.entries(groupedByDate)) {
                const training = new TrainingModel();
                training.name = data.name;
                training.dateDebut = date; // Toutes les demi-journées ont la même date
                training.dateFin = date;
                training.id = data.id;
                sessions.push(training);
              }
            } else {
              console.error("Les demi-journées ne sont pas disponibles dans la réponse de l'API.");
            }
          } else {
            // Ajouter la session si les jours correspondent
            const training = new TrainingModel();
            training.name = data.name;
            training.dateDebut = data.start_date;
            training.dateFin = data.end_date;
            training.id = data.id;
            sessions.push(training);
          }
        }
      }

      console.log(sessions);
      setSession(sessions);
    } catch (error) {
      console.error("Erreur lors du traitement des sessions :", error);
    } finally {
      setLoading(false);
    }
  };
  return (CalendarView({ session, loading }))
}

export default CalendarController;